


















































































































































































































































































































































































































































// import { remote } from 'electron'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { loadConnection, createConnection, updateConnection, loadSuggestConnections } from '@/utils/api/connection'
import getClientId from '@/utils/getClientId'
import { ConnectionModel, SearchCallBack, NameCallBack, FormRule } from './types'
import { getMQTTProtocol } from '@/utils/mqttUtils'
import Editor from '@/components/Editor.vue'
import deepMerge from '@/utils/deepMerge'

@Component({
  components: {
    Editor,
  },
})
export default class ConnectionCreate extends Vue {
  @Prop({ required: true }) public oper!: 'edit' | 'create' | undefined

  @Getter('currentLang') private getterLang!: Language
  @Getter('advancedVisible') private getterAdvancedVisible!: boolean
  @Getter('willMessageVisible') private getterWillMessageVisible!: boolean
  @Getter('currentTheme') private theme!: Theme
  @Getter('allConnections') private allConnections!: ConnectionModel[] | []

  @Action('CHANGE_ACTIVE_CONNECTION') private changeActiveConnection!: (payload: Client) => void
  @Action('TOGGLE_ADVANCED_VISIBLE') private toggleAdvancedVisible!: (payload: { advancedVisible: boolean }) => void
  @Action('TOGGLE_WILL_MESSAGE_VISIBLE')
  private toggleWillMessageVisible!: (payload: { willMessageVisible: boolean }) => void

  private willMessageVisible = true
  private advancedVisible = true
  private payloadType = 'plaintext'
  private willLabelWidth = 160
  private suggestConnections: ConnectionModel[] | [] = []
  private oldName = ''

  private record: ConnectionModel = {
    clientId: getClientId(),
    name: '',
    clean: true,
    protocol: 'ws',
    host: 'mqtt-service.dev-altamedia.com',
    keepalive: 60,
    connectTimeout: 10,
    reconnect: false,
    username: '',
    password: '',
    path: '/mqtt',
    port: 80,
    ssl: false,
    certType: '',
    rejectUnauthorized: false,
    ca: '',
    cert: '',
    key: '',
    mqttVersion: '3.1.1',
    subscriptions: [],
    messages: [],
    unreadMessageCount: 0,
    client: {
      connected: false,
    },
    will: {
      lastWillTopic: '',
      lastWillPayload: '',
      lastWillQos: 0,
      lastWillRetain: false,
      properties: {
        payloadFormatIndicator: undefined,
        willDelayInterval: undefined,
        messageExpiryInterval: undefined,
        contentType: '',
      },
    },
    sessionExpiryInterval: undefined,
    receiveMaximum: undefined,
    topicAliasMaximum: undefined,
  }

  @Watch('record', { immediate: true, deep: true })
  private handleMqttVersionChange(val: ConnectionModel) {
    if (val.mqttVersion === '3.1.1') {
      this.willLabelWidth = 160
    } else {
      this.willLabelWidth = 180
    }
  }

  get rules() {
    return {
      name: [
        { required: true, message: this.$t('common.inputRequired') },
        { validator: this.validateName, trigger: 'blur' },
      ],
      clientId: [{ required: true, message: this.$t('common.inputRequired') }],
      path: [{ required: true, message: this.$t('common.inputRequired') }],
      host: [{ required: true, message: this.$t('common.inputRequired') }],
      port: [{ required: true, message: this.$t('common.inputRequired') }],
      certType: [{ required: true, message: this.$t('common.selectRequired') }],
      ca: [{ required: true, message: this.$t('common.inputRequired') }],
    }
  }

  get vueForm(): VueForm {
    return this.$refs.form as VueForm
  }

  private async loadDetail(id: string) {
    const res: ConnectionModel | null = await loadConnection(id)
    if (res) {
      deepMerge(this.record, res)
      this.oldName = res.name
      this.record.protocol = getMQTTProtocol(res)
      if (res.rejectUnauthorized === undefined) {
        this.record.rejectUnauthorized = false
      }
    }
  }

  private save() {
    this.vueForm.validate(async (valid: boolean) => {
      if (!valid) {
        return false
      }
      const data = { ...this.record }
      this.trimString(data)
      let res: ConnectionModel | null = null
      let msgError = ''
      if (this.oper === 'create') {
        res = await createConnection(data)
        msgError = this.$t('common.createfailed') as string
      } else {
        res = await updateConnection(data.id as string, data)
        msgError = this.$t('common.editfailed') as string
      }
      if (res) {
        this.changeActiveConnection({
          id: res.id as string,
          client: {},
          messages: [],
        })
        this.$emit('connect')
        this.$router.push(`/recent_connections/${res.id}`)
      } else {
        this.$message.error(msgError)
      }
    })
  }

  private setClientID() {
    this.record.clientId = getClientId()
  }

  private getFilePath(e: MouseEvent, key: 'ca' | 'cert' | 'key') {
    let file = e.target as HTMLInputElement
    let vue = this
    if (file.files) {
      //读取本地文件
      let reader = new FileReader()
      reader.readAsText(file.files[0])
      reader.onload = function () {
        if (this.result) {
          vue.record[key] = this.result as string
        }
      }
    }
  }

  private handleSSL(val: boolean) {
    const { protocol } = this.record
    this.changeProtocol(protocol, val)
    if (!val) {
      this.record.certType = ''
    }
  }

  private changeProtocol(protocol: Protocol | undefined, isSSL: boolean): void | boolean {
    if (!protocol) {
      return false
    }
    if (/ws/gi.test(protocol)) {
      this.record.protocol = isSSL ? 'wss' : 'ws'
    }
  }

  private handleBack(id: string) {
    if (this.oper === 'create' && id === '0') {
      this.$router.push('/recent_connections')
    } else {
      this.$router.push(`/recent_connections/${id}`)
    }
  }

  private trimString(data: ConnectionModel) {
    const { name, host, password } = data
    data.name = name.trim()
    data.host = host.trim()
    data.password = password.trim()
  }

  private handleCollapse(part: 'advanced' | 'willMessage') {
    if (part === 'advanced') {
      this.advancedVisible = !this.advancedVisible
      this.toggleAdvancedVisible({
        advancedVisible: this.advancedVisible,
      })
    } else if (part === 'willMessage') {
      this.willMessageVisible = !this.willMessageVisible
      this.toggleWillMessageVisible({
        willMessageVisible: this.willMessageVisible,
      })
    }
  }

  private async validateName(rule: FormRule, name: string, callBack: NameCallBack['callBack']) {
    for (const connection of this.allConnections) {
      if (this.oper === 'create' && connection.name === name) {
        callBack(`${this.$t('connections.duplicateName')}`)
      } else if (this.oper === 'edit' && name !== this.oldName && connection.name === name) {
        callBack(`${this.$t('connections.duplicateName')}`)
      }
    }
  }

  private async loadData(reload: boolean = false): Promise<void> {
    this.suggestConnections = await loadSuggestConnections()
  }

  private createFilter(queryName: string) {
    return (connectionItem: ConnectionModel) => {
      return connectionItem.name.toLowerCase().indexOf(queryName.toLowerCase()) === 0
    }
  }

  private querySearchName(queryName: string, cb: SearchCallBack['callBack']) {
    const connections = [...this.suggestConnections]
    const results = queryName ? connections.filter(this.createFilter(queryName)) : connections
    cb(results.reverse())
  }

  private handleSelectName(item: ConnectionModel) {
    const { id, ...oneConnection } = item
    oneConnection.clientId = getClientId()
    this.record = oneConnection
  }

  private created() {
    this.loadData()
    const { id } = this.$route.params
    if (this.oper === 'edit' && id !== '0') {
      this.loadDetail(id)
    }
    this.advancedVisible = this.getterAdvancedVisible
    this.willMessageVisible = this.getterWillMessageVisible
  }
}
